import axios from '../utils/axios';

export default function fetchRecruiterProfile(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/recruiter/', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
